import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "appearance"];
import * as React from 'react';
import cn from 'classnames';
import { Enum, DensityType } from '../../../library';
import { Pane } from '../../pane';
export var ListAppearance = Enum({
  NONE: 'none',
  INLINE: 'inline',
  BULLETED: 'bulleted',
  NUMBERED: 'numbered'
});
export var List = function List(props) {
  var className = props.className,
    appearance = props.appearance,
    paneProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn('list', _defineProperty(_defineProperty(_defineProperty({}, "-".concat(props.appearance), props.appearance !== ListAppearance.NONE), '-relaxed', props.density === DensityType.RELAXED), '-compact', props.density === DensityType.COMPACT), className);
  return React.createElement(Pane, _extends({
    as: props.appearance === ListAppearance.NUMBERED ? 'ol' : 'ul',
    className: classNames
  }, paneProps));
};
List.displayName = 'List';
List.defaultProps = {
  appearance: ListAppearance.NONE,
  density: DensityType.NORMAL
};